<template>
  <div>
    <div class="d-flex justify-content-between">
      <h1 class="page-header">{{ $t('studentScoringEntry.pageTitle') }}</h1>
      <ts-breadcrumb
        :items="[
          { text: $t('toHomePage'), href: '/' },
          {
            text: $t('studentScoringEntry.tableEntry'),
            href: '/student-scoring-entries'
          },
          {
            text: $t('create'),
            active: true
          }
        ]"
      />
    </div>
    <ts-loading-banner :loading="loading">
      <ts-card>
        <ts-card-wrapper>
          <div class="row">
            <div class="col-md-12">
              <HeadderComponent
                v-model="model"
                @loading="v => (loading = v)"
                @fetchStudent="fetchStudent"
                @scoreEntities="setScoreEntities"
                @on-cycle-value-change="onOnCycleValueChange"
                @clearEntities="() => (scoreEntities = [])"
                @clearSubject="onClearSubject"
                :selectedSubjectId="selectedSubjectId"
              />
            </div>
          </div>
          <br />
        </ts-card-wrapper>
      </ts-card>
      <ts-card class="ts-mt-4">
        <ts-card-wrapper>
          <div class="ts-overflow-auto">
            <NumberingScoreTable
              v-model="model"
              v-if="model.score_type == 1"
              :students="students"
              :scoreEntities="scoreEntities"
              :selectedSubjectId="selectedSubjectId"
              @loading="v => (loading = v)"
              ref="numering"
            />
            <div
              v-if="model.score_type == null"
              class="ts-h-64 ts-flex ts-items-center ts-justify-center"
            >
              <div class="ts-text-center ts-opacity-50">
                <i class="far fa-list-alt fa-4x"></i>
                <h1 class="ts-font-bold ts-text-gray-600">No Record</h1>
              </div>
            </div>
          </div>
          <div class="ts-space-x-3 ts-flex ts-justify-end ts-mt-3">
            <ts-button
              @click="$router.push({ name: 'student-scoring-entry' })"
              >{{ $t('cancel') }}</ts-button
            >
            <ts-button color="primary" @click.prevent="onStore">{{
              $t('save')
            }}</ts-button>
          </div>
        </ts-card-wrapper>
      </ts-card>
    </ts-loading-banner>
  </div>
</template>

<script>
import { Errors } from 'form-backend-validation'
import HeadderComponent from './table-entry-component/header-component.vue'
import NumberingScoreTable from './table-entry-component/numberingScoreTable.vue'
import { formViewModel, store } from '@/api/student-scoring-table-entry'

export default {
  name: 'scoringEntryAsTable',
  components: {
    HeadderComponent,
    NumberingScoreTable
  },
  data() {
    return {
      loading: false,
      errors: new Errors(),
      students: [],
      scoreEntities: [],
      selectedSubjectId: {
        id: []
      },
      model: {
        class_id: null,
        grade_id: null,
        scoring_cycle_id: null, // 1: monthly , 2 semester
        score_type: null,
        acps_id: null,
        cycle_value: null,
        acp_id: null,
        ac_year_id: null,
        ac_term_id: null,
        program_structure_id: null,
        ac_category_id: 0,
        score_sc_bas_id: 1, // item base default
        sc_item_subject_comp_list: []
      }
    }
  },
  created() {},
  methods: {
    fetchStudent() {
      this.loading = true
      return formViewModel({
        params: {
          fnName: 'students',
          class_id: this.model.class_id
        }
      })
        .then(({ data }) => {
          this.students = data.students
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
        .finally(() => {
          this.loading = false
        })
    },
    setScoreEntities(scoreEntities) {
      this.scoreEntities = scoreEntities
    },
    onOnCycleValueChange() {
      this.$refs.numering.onCycleValue()
    },
    onStore() {
      this.loading = true
      store(this.model)
        .then(response => {
          this.$toasted.success(response.message)
          this.$refs.numering.onCycleValue()
        })
        .catch(error => {
          this.$toasted.error(error.message)
          this.errors = new Errors(error.errors)
        })
        .finally(() => (this.loading = false))
    },
    onClearSubject(){
      this.students = []
      this.selectedSubjectId.id = [];
      this.model.sc_item_subject_comp_list = []
    }
  }
}
</script>
